export enum ENVIRONMENTS {
  DEV = "dev",
  QA = "qaint",
  STG = "stg",
  PPE = "ppe",
  PROD = "prod",
}

export const BV_ENABLE_LOG_KEYWORDS = ["start_log_trace", "enable_log_trace"];
export const BV_DISABLE_LOG_KEYWORDS = ["stop_log_trace", "disable_log_trace"];
export const SCREEN_PRINT_EVENT = "screen.print.event";
